import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { Formik, Form } from 'formik';
import TextField from '@components/Form/TextField';
import Button, { SIZE } from '@components/Button';

const SignInForm = observer(({ onSubmit }) => (
  <Formik
    initialValues={{ email: '', password: '' }}
    validate={values => {
      const errors = {};
      if (!values.email) {
        errors.email = 'Required';
      }
      if (!values.password) {
        errors.password = 'Required';
      }

      return errors;
    }}
    onSubmit={async (values, { setSubmitting, setErrors, resetForm }) => {
      await onSubmit(values, setSubmitting, setErrors, resetForm);
    }}
  >
    {({ isSubmitting }) => (
      <Form>
        <TextField label="Email" type="email" name="email" />
        <TextField label="Password" type="password" name="password" />
        <Button
          type="submit"
          text="Login"
          disabled={isSubmitting}
          loading={isSubmitting}
          size={SIZE.LARGE}
          fullWidth
        />
      </Form>
    )}
  </Formik>
));

SignInForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default SignInForm;
